module.exports = __webpack_public_path__ + "img/unknown-error.f111ef83.svg";